import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/actions/orderActions";
function CreateOrder({ token }) {
  const [products, setProducts] = useState([]);
  const [order, setOrder] = useState({});
  const [qty, setQty] = useState(0);
  const [prodToBuy, setProdTobuy] = useState([]);
  const dispatch = useDispatch();
  const productsToBuy = useSelector((state) => state.orders);

  /*  let productsToBuy = [];  */
  /* console.log(productsToBuy);
  const bougthProduct = productsToBuy.find((item) => item.id === prodToBuy.id);
  if (bougthProduct === []) {
    prodToBuy = { ...prodToBuy.id, qty: qty };
    dispatch(actions.createOrder(prodToBuy));
  } else {
    prodToBuy.qty = qty; */
  /*  dispatch(actions.createOrder(prodToBuy)); 
  }

  /*  dispatch(actions.createOrder(prodToBuy)); */
  console.log(qty);
  console.log(productsToBuy);

  const handleCreate = (product, qty, productsToBuy) => {
    const bougthProduct = productsToBuy.find((item) => item.id === product.id);
    if (bougthProduct === []) {
      product = { ...product.id, qty: qty };
      dispatch(actions.createOrder(product));
    } else {
      product.qty = qty;
      /*  dispatch(actions.createOrder(product)); */
    }
  };

  try {
    const getProducts = async () => {
      const response = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + "/api/products",
        headers: { Authorization: `Bearer ${token}` },
      });

      setProducts(response.data);
    };

    useEffect(() => {
      getProducts();
    }, []);
  } catch (error) {
    console.log("Error: ", error);
  }

  try {
    const createOrder = async () => {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_API_URL + "/api/orders",
        headers: { Authorization: `Bearer ${token}` },
      });

      setOrder(response.data);
      /* dispatch(actions.createOrder(order)); */
    };

    /*  useEffect(() => {
      createOrder();
    }, []); */
  } catch (error) {
    console.log("Error: ", error);
  }

  return (
    <div className="d-flex flex-column w-100 dashboard-pages">
      <h1 className="h3 ms-3 mb-4">Order to make</h1>
      <div className="d-flex justify-content-between mx-3 mb-3">
        <input
          type="text"
          placeholder="Search product"
          className="w-25 border-1 ps-2 bg-light rounded"
        />
        <Button
          variant="primary"
          /* onClick={handleShowCreate} */ className="fs-5"
        >
          +Set Order
        </Button>
      </div>
      <div className="table-responsive w-100">
        <table className="table table-striped table-hover align-middle border rounded shadow">
          <thead>
            <tr>
              <th className="ps-3">ID</th>
              <th>Name</th>
              <th>Images</th>
              <th>Price</th>
              <th>Stock</th>
              <th>Rating</th>
              <th>Sale</th>
              <th>highlight</th>
              <th>Slug</th>
              <th>CreatedAt</th>
              <th>updatedAt</th>
              <th>Qty</th>
            </tr>
          </thead>
          <tbody>
            {products &&
              products.map((product) => (
                <tr key={product.id}>
                  <td className="fw-bold ps-3">{product.id}</td>
                  <td>{product.name}</td>
                  <td>
                    {/*  {product.images.img1}, {product.images.img2} */}
                    <img
                      src={`process.env.REACT_APP_IMAGES_URL + ${product.images.img1} alt="image"`}
                    />
                  </td>
                  <td>${product.price}</td>
                  <td>{product.stock}</td>
                  <td>{product.rating}</td>
                  <td>{product.sale ? "Sale" : "No"}</td>
                  <td>{product.highlight ? "Highlight" : "No"}</td>
                  <td>{product.slug}</td>
                  <td>{product.createdAt /* toLocaleDateString() */}</td>
                  <td>{product.updatedAt /* toLocaleDateString() */}</td>
                  <td>
                    <input
                      className="me-2 w-25 fw-bold "
                      variant="outline-dark"
                      name="qty"
                      vlaue={qty}
                      onChange={(e) => {
                        /* setQty(e.target.value);
                        setProdTobuy(product); */
                        handleCreate(product, e.target.value, productsToBuy);
                      }}
                    />
                    <i className="bi bi-pencil fs-6 me-2"></i>

                    {/* <Button
                      variant="outline-secondary"
                     
                    >
                      <i className="bi bi-x-octagon-fill fs-6"></i>
                    </Button> */}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CreateOrder;
